import { render, staticRenderFns } from "./AccomodationGallery.vue?vue&type=template&id=0a94aa1c&scoped=true"
import script from "./AccomodationGallery.vue?vue&type=script&lang=js"
export * from "./AccomodationGallery.vue?vue&type=script&lang=js"
import style0 from "./AccomodationGallery.vue?vue&type=style&index=0&id=0a94aa1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94aa1c",
  null
  
)

export default component.exports